import { motion } from 'framer-motion';
import type { PresentationSlide } from '../../shared/protocol.ts';
export function PresentationScreen({slide}:{slide:PresentationSlide}) {
  return <motion.section key={slide.arabicTitle} dir="rtl" initial={{opacity:0,y:14}} animate={{opacity:1,y:0}}
    className="rafed-idle relative flex h-full flex-col justify-center overflow-hidden px-[10vw]">
    <div className="absolute -left-[12vw] top-[8vh] h-[65vw] w-[65vw] rounded-full border border-cyan-500/10" />
    <div className="absolute -left-[4vw] top-[16vh] h-[48vw] w-[48vw] rounded-full border border-cyan-500/10" />
    <img src="/brand/rafed-logo.svg" alt="رافد RAFED" className="relative mb-[6vh] w-[clamp(90px,10vw,170px)]" />
    <div className="relative max-w-5xl">
      <div className="mb-6 h-1.5 w-14 rounded-full bg-cyan-500" />
      <h1 className="text-[clamp(34px,5.6vw,90px)] font-bold leading-[1.4]">{slide.arabicTitle}</h1>
      <p className="mt-[3vh] max-w-3xl text-[clamp(17px,2vw,30px)] leading-loose text-dim">{slide.subtitle}</p>
      <div className="mt-[6vh] flex flex-wrap gap-3">{slide.points.map((point,i)=><span key={point} className="rafed-idle-chip rounded-full px-6 py-3 text-[clamp(13px,1.3vw,23px)]"><span className="me-3 opacity-50">0{i+1}</span>{point}</span>)}</div>
    </div>
  </motion.section>;
}
